<template>
    <div>
        <el-tabs v-model="activeName2" type="card"  @tab-click="handleClick" >
            <el-tab-pane label="折线统计" name="first" :key="'first'"  >
            <child1 v-if="firstisRouterAlive" ></child1>           
            </el-tab-pane> 
            <el-tab-pane label="表格报表" name="second" :key="'second'" >
                <child2 v-if="secondisRouterAlive" ></child2>             
            </el-tab-pane>              
        </el-tabs>
    </div>
</template>


<script>
import chartBar from '@/views/ShopManagement/BuesinessStatistics/chartBar.vue'
import table from '@/views/ShopManagement/BuesinessStatistics/table.vue'


  export default {
     name: 'tabZujian',
    components:{
        child1:chartBar,
        child2:table,
        // child2:this.$nextTick(() => { this.EChart= resolve => require([chartBar],resolve)}
        // child2:resolve => {require(['@/views/MemberManagement/chart/chartBar.vue'], resolve)},
    },
    data() {
      return {
          TenancyId:'',
        activeName2: 'second',
        // 刷新子组件
        firstisRouterAlive: true,
       secondisRouterAlive:true,
      };     
    },
    methods:{
         handleClick(tab, event) {
      
      //刷新组件解决样式style值丢失问题
       this.reload(tab);
      },  
        reload (tab) {
          if(tab.name=='first')
        {
          // console.log(tab.name);
         this.firstisRouterAlive = false
        this.$nextTick(() => (this.firstisRouterAlive = true))

        }
        if(tab.name=='second')
        {
          // console.log(tab.name);
         this.secondisRouterAlive = false
        this.$nextTick(() => (this.secondisRouterAlive = true))

        }
     
   } 
    }
  }   
</script>





// WEBPACK FOOTER //
// BuesinessStatistics.vue?11b7b224